import { render, staticRenderFns } from "./WashbasinAdmin.vue?vue&type=template&id=33473bf6&"
import script from "./WashbasinAdmin.vue?vue&type=script&lang=js&"
export * from "./WashbasinAdmin.vue?vue&type=script&lang=js&"
import style0 from "./WashbasinAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports